import EdoCapitalCallPortion from "./EdoCapitalCallPortion";

export default EdoCapitalCallPortion;
